export default __webpack_public_path__ + "static/media/way to arlabel.af885f2f.png";